import { jsx as _jsx } from "react/jsx-runtime";
export const OptionalLink = ({ href, className, ...props }) => {
    if (href === null)
        return _jsx("span", { className: `${className} just-text`, ...props });
    return _jsx("a", { href: href, className: className, ...props });
};
